module.exports = __webpack_public_path__ + "img/only-you_white.414f10f7.svg";